(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    var closeBtn = document.getElementById('sticky-atc-close-btn-custom');
    var stickyAtcContainer = document.querySelector('sticky-atc-container');
    var localStorageKey = 'stick-cta-closed';

    // Check if closed within last 24 hours
    var closedData = localStorage.getItem(localStorageKey);
    /*if (closedData) {
        try {
            var closedObj = JSON.parse(closedData);
            var now = Date.now();
            if (closedObj && closedObj.expires > now) {
                if (stickyAtcContainer) {
                    stickyAtcContainer.style.display = 'none';
                }
                document.body.classList.add('sticky-cta-closed');
            }
        } catch(e) {}
    }
    */

    if (closeBtn) {
        closeBtn.addEventListener('click', function(e) {
            e.preventDefault();
            if (stickyAtcContainer) {
                stickyAtcContainer.style.display = 'none';
            }
            var expires = Date.now() + 24 * 60 * 60 * 1000; // 24 hours
            localStorage.setItem(localStorageKey, JSON.stringify({expires: expires}));
            document.body.classList.add('sticky-cta-closed');
        });
    }
});
  } catch(e) { console.error(e); }
})();

})();
